import { Field, Form, Formik } from "formik"
import React, { useState } from "react"
import { IStep } from "../interface"
import { 
    ButtonContainer, 
    InputContainer, 
    RowForButton, 
    RowForInput, 
    TitleField 
} from "./style"
import * as Yup from "yup";
import Input from "../../Input";
import Button from "../../Button";
import { useSelector } from "react-redux";
import Select from "../../Select";
import { toastCreate, toastUpdate } from "../../../utils/notifications/toast";
import { IGroupProduct } from "../../../views/ecommerce/group/interfaces";
import { getGroups } from "../../../hooks/getGroups";
import { addProduct } from "../../../hooks/addProduct";
import { TIME_INFO, TIME_RESULT } from "../../../utils/notifications/time";

const StepOne = ({
    setData,
    setStep,
}: IStep
): React.ReactElement => {
    const [groups, setGroups] = useState<Array<IGroupProduct>>([])
    const login = useSelector((state: {login: any}) => state.login);
    const STEP_ADD_DETAIL_PRODUCT = 2
    const EMPTY = 0
    const formValidationWithYup = Yup.object().shape({
        name: Yup.string().required(),
        description: Yup.string().required(),
        amount: Yup.string().required(),
        group: Yup.string().required()
    })  

    return (
        <div>
            <Formik
                initialValues={{
                    name: "",
                    description: "",
                    amount: "",
                    group: ""
                }}
                validationSchema={formValidationWithYup}
                onSubmit={async (values) => {
                    const { isError, block } = await addProduct(values, login)

                    if (isError) {
                        toastUpdate(
                            "submitProduct", 
                            "error", 
                            TIME_RESULT, 
                            "Falha ao criar produto. Tente novamente ou contate o suporte."
                        )
                    }

                    else {
                        setStep && setStep(STEP_ADD_DETAIL_PRODUCT)
                        setData && setData(block)
                    }
                }}
            >
                {({values, errors, handleChange, dirty, isValid, touched}) => {
                    return (
                        <Form>
                            <TitleField>
                                Adicionar produto
                            </TitleField>
                            <RowForInput>
                                <InputContainer>
                                    <Field 
                                        name="name" 
                                        type="text" 
                                        placeholder="Nome"
                                        maxLength={28}
                                        isError={touched.name && errors.name}
                                        as={Input}
                                    />
                                </InputContainer>
                                <InputContainer>
                                    <Field 
                                        name="description"  
                                        type="text" 
                                        isError={touched.description  && errors.description}
                                        placeholder="Descrição"
                                        as={Input}
                                    />
                                </InputContainer>
                            </RowForInput>
                            <RowForInput>
                                <InputContainer>
                                    <Field 
                                        name="amount" 
                                        type="string" 
                                        isError={touched.amount && errors.amount}
                                        placeholder="Valor"
                                        as={Input}
                                    />
                                </InputContainer>
                                <InputContainer 
                                    onMouseEnter={() => {
                                        groups.length === EMPTY && getGroups(login, setGroups)
                                    }}
                                >
                                    <Field 
                                        name="group"
                                        onChange={handleChange}
                                        isError={touched.group && errors.group}
                                        value={values.group}
                                        as={Select}
                                    >
                                        <option>{ groups?.length === EMPTY && "Selecione um grupo" }</option>
                                        {
                                            groups.map((group: IGroupProduct) => {
                                                return (
                                                    <option value={group.id} key={group.id}>
                                                        { group.description }
                                                    </option>
                                                )
                                            })
                                        }

                                    </Field>
                                </InputContainer>
                            </RowForInput>
                            <RowForButton>
                                <ButtonContainer>
                                    <Button 
                                        onClick={() => {
                                            toastCreate(
                                                "submitProduc", 
                                                "info", 
                                                TIME_INFO, 
                                                "Processando"
                                            )
                                        }} 
                                        disabled={ !(dirty && isValid)}
                                        type="submit">
                                            Adicionar Produto
                                    </Button>
                                </ButtonContainer>
                            </RowForButton>
                        </Form>
                    )
                }}
            </Formik>
        </div>
    )
}

export default StepOne